// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/google-vertex.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const GOOGLE_VERTEX_MODELS: ModelCatalog<typeof values, "google-vertex"> =
	flattenModelCatalog("google-vertex", values);
